// src/firebase.ts
import {initializeApp} from "firebase/app";
import {deleteToken, getMessaging, getToken, isSupported, onMessage} from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyB2WMbHThNE2TTyEKRGkMa8tb2c5hLRzQ8",
    authDomain: "melon-business-travel.firebaseapp.com",
    projectId: "melon-business-travel",
    storageBucket: "melon-business-travel.appspot.com",
    messagingSenderId: "245763126619",
    appId: "1:245763126619:web:218f2e78f12e2380fdd67e",
    measurementId: "G-Y5PQGB038J"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const getFirebaseToken = async () => {
    try {
        if (await isSupported()) {
            const permission = await Notification.requestPermission();
            if (permission === "granted") {
                // регистрируем корневой SW идемпотентно register вернёт существующую регистрацию
                // не используем serviceWorker.ready он может зависнуть или отдать кастом scope SW который тут же чистится
                let swRegistration: ServiceWorkerRegistration | undefined;
                if ("serviceWorker" in navigator) {
                    try {
                        swRegistration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
                    } catch (e) {
                        console.log("Не удалось зарегистрировать service worker", e);
                    }
                }
                // serviceWorkerRegistration передаём ТОЛЬКО если он есть иначе firebase падает на undefined.pushManager
                const tokenOptions: { vapidKey?: string; serviceWorkerRegistration?: ServiceWorkerRegistration } = {
                    vapidKey: process.env.REACT_APP_FCM_VAPID_KEY,
                };
                if (swRegistration) {
                    tokenOptions.serviceWorkerRegistration = swRegistration;
                }
                const currentToken = await getToken(messaging, tokenOptions);
                if (currentToken) {
                    // console.log("FCM токен:", currentToken);
                    return currentToken;
                } else {
                    console.log("Нет FCM токенов, для генерации нужно запросить разрешения на уведомления.");
                }
            } else {
                console.log("Уведомления запрещены.");
            }
        } else {
            console.log("Firebase Messaging не поддерживается.");
        }
    } catch (error) {
        console.error("Ошибка при получении FCM токена. ", error);
    }
};

export const deleteFirebaseToken = async () => {
    try {
        const deleted = await deleteToken(messaging);
        if (deleted) {
            console.log("FCM токен успешно удален.");
        } else {
            console.log("Не удалось удалить FCM токен.");
        }
        return deleted;
    } catch (error) {
        console.error("Ошибка при удалении FCM токена. ", error);
        return false;
    }
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            console.log("[firebase] Получено сообщение", payload);
            resolve(payload);
        });
    });

// постоянная подписка на foreground сообщения возвращает функцию отписки
export const onForegroundMessage = (callback: (payload: any) => void) =>
    onMessage(messaging, callback);